import IInputProps, { ISlimInputProps } from "./IInputProps";
import InputContainer, { InputContainerRow } from "./InputContainer";
import { StringInputSlim } from "./StringInput";

export default <T,>({ name, label, formik }: IInputProps<T, string>) => {
    return (
        <InputContainer label={label} name={name} formik={formik}>
            <PasswordInputSlim name={name} formik={formik} />
        </InputContainer>
    );
}

export const PasswordInputRow = <T,>({ name, label, formik }: IInputProps<T, string>) => {
    return (
        <InputContainerRow name={name} label={label} formik={formik}>
            <PasswordInputSlim name={name} formik={formik} />
        </InputContainerRow>
    );
}

export const PasswordInputSlim = <T,>({ name, formik }: ISlimInputProps<T, string>) => {
    return (
        <StringInputSlim
            type="password"
            name={name}
            formik={formik}
        />
    );
}